var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D491B859-85A0-4E45-9977-1CAC7017DC13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registruokit\\u0117s-vizitui",
    transform: "translate(-735.000000, -531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(515.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LT_flag-Copy-3",
    transform: "translate(220.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,6 L27,6 L0,6 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    fill: "#FDB913"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006A44",
    x: 0,
    y: 6,
    width: 27,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12 L27,12 L27,16 C27,17.1045695 26.1045695,18 25,18 L2,18 C0.8954305,18 1.3527075e-16,17.1045695 0,16 L0,12 L0,12 Z",
    id: "Rectangle-Copy-2",
    fill: "#C1272D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLt);
export default __webpack_public_path__ + "static/media/flag-lt.7b9346a512a7f9a9fd024bf484f05b07.svg";
export { ForwardRef as ReactComponent };